export default "__VITE_ASSET__BagpdLOg__"